import React from "react";
import { connect } from "react-redux";
import { getProduct, IProduct, updateProduct } from "../../../redux/modules/products";
import ProductForm from "../../ProductForm";
import { withRouter } from "../../../hooks/withRouter";
import { RootState } from "../../../redux";
import ProductOperationList from "../../ProductOperationList";
import SupplyOperationForm from "../../SupplyOperationForm";
import SellOperationForm from "../../SellOperationForm";
import UseOperationForm from "../../UseOperationForm";
import { formatPrice } from "../../../utils/price-utils";
import "./product-page.css";

interface ProductPageProps {
  products?: IProduct[];
  router?: { params?: { id?: string }; location?: { search?: string } };
  getProduct?: (productId: number) => void;
  updateProduct?: (product: IProduct) => void;
}

interface ProductPageState {
  showSupplyForm: boolean;
  showSellForm: boolean;
  showUseForm: boolean;
}

class ProductPage extends React.Component<ProductPageProps, ProductPageState> {
  constructor(props: ProductPageProps) {
    super(props);
    this.state = {
      showSellForm: false,
      showUseForm: false,
      showSupplyForm: false
    };
  }

  componentDidMount() {
    const id = this.props?.router?.params?.id;
    if (!id) {
      return;
    }
    this.props.getProduct && this.props.getProduct(+id);
  }

  showForm = (form: string) => {
    if (form === "SUPPLY") {
      this.setState({
        showSellForm: false,
        showUseForm: false,
        showSupplyForm: true
      });
    } else if (form === "SELL") {
      this.setState({
        showSellForm: true,
        showUseForm: false,
        showSupplyForm: false
      });
    } else if (form === "USE") {
      this.setState({
        showSellForm: false,
        showUseForm: true,
        showSupplyForm: false
      });
    }
  };

  hideForms = () => {
    this.setState({
      showSellForm: false,
      showUseForm: false,
      showSupplyForm: false
    });
  };

  getProduct = () => {
    const pageId = this.props?.router?.params?.id;
    if (!this.props.products || !pageId) {
      return null;
    }
    return this.props.products.find(({ id }) => id === +pageId);
  };

  renderProductForm(product: IProduct) {
    if (!product.archived && (this.state.showSellForm || this.state.showSupplyForm || this.state.showUseForm)) {
      return (
        <div className="product-page__cancel-section">
          <button className="product-page__btn-cancel" onClick={this.hideForms}>
            <span className="product-page__btn-cancel-icon">←</span>
            Скасувати
          </button>
        </div>
      );
    } else {
      return (
        <>
          <div className="product-page__form-container">
            <ProductForm product={product} saveHandler={product.archived ? undefined : this.props.updateProduct} readOnly={product.archived} />
          </div>
          {!product.archived && (
            <div className="product-page__operations-section">
              <div className="product-page__operations-card">
                <h3 className="product-page__operations-title">Операції з товаром</h3>
                <div className="product-page__operations-buttons">
                  <button className="product-page__btn-operation product-page__btn-operation--supply" onClick={() => this.showForm("SUPPLY")}>
                    <span className="product-page__btn-operation-icon">📥</span>
                    Поповнити товар
                  </button>
                  {this.renderSellAndUseButtons(product)}
                </div>
              </div>
            </div>
          )}
          <div className="product-page__operations-list">
            <ProductOperationList product={product} />
          </div>
        </>
      );
    }
  }

  renderSellAndUseButtons(product: IProduct) {
    if (!product.amount) {
      return null;
    }
    return (
      <>
        <button className="product-page__btn-operation product-page__btn-operation--sell" onClick={() => this.showForm("SELL")}>
          <span className="product-page__btn-operation-icon">💰</span>
          Продати товар
        </button>
        <button className="product-page__btn-operation product-page__btn-operation--use" onClick={() => this.showForm("USE")}>
          <span className="product-page__btn-operation-icon">📤</span>
          Списати товар
        </button>
      </>
    );
  }

  renderOperationForms = (product: IProduct) => {
    if (this.state.showSupplyForm) {
      return (
        <div className="product-page__operation-form-container">
          <SupplyOperationForm product={product} callback={this.hideForms} />
        </div>
      );
    } else if (this.state.showSellForm) {
      return (
        <div className="product-page__operation-form-container">
          <SellOperationForm product={product} callback={this.hideForms} />
        </div>
      );
    } else if (this.state.showUseForm) {
      return (
        <div className="product-page__operation-form-container">
          <UseOperationForm product={product} syncCallBack={this.hideForms} />
        </div>
      );
    }
  };

  renderProductData() {
    const pageId = this.props?.router?.params?.id;
    if (!this.props.products || !pageId) {
      return (
        <div className="product-page__loading">
          <p className="product-page__loading-text">Завантаження товару...</p>
        </div>
      );
    }
    const product = this.props.products.find(({ id }) => id === +pageId);
    if (!product) {
      return (
        <div className="product-page__empty">
          <p className="product-page__empty-text">Товар з id: {pageId} не знайдено</p>
        </div>
      );
    }
    return (
      <>
        <div className="product-page__header">
          <div className="product-page__header-content">
            <div className="product-page__header-icon">📦</div>
            <div className="product-page__header-info">
              <div className="product-page__title-row">
                <h1 className="product-page__title">{product.archived ? "Товар" : "Редагувати Товар"}</h1>
                {product.archived && <span className="product-page__archived-badge">Архів</span>}
              </div>
              <p className="product-page__subtitle">{product.name}</p>
              <div className="product-page__header-details">
                <span className="product-page__header-detail">
                  <span className="product-page__header-detail-label">На складі:</span>{" "}
                  <span className="product-page__header-detail-value">
                    {product.amount} {product.unitType === "piece" ? "шт" : "мл"}
                  </span>
                </span>
                <span className="product-page__header-detail">
                  <span className="product-page__header-detail-label">Ціна продажу:</span>{" "}
                  <span className="product-page__header-detail-value product-page__header-detail-value--price">{formatPrice(product.sellPrice)} грн</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        {this.renderProductForm(product)}
        {this.renderOperationForms(product)}
      </>
    );
  }

  render() {
    return (
      <div className="product-page">
        {this.props.products ? (
          this.renderProductData()
        ) : (
          <div className="product-page__loading">
            <p className="product-page__loading-text">Завантаження товару...</p>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => {
  return { products: Object.values(state.productsState.products) };
};

export default withRouter(
  connect(mapStateToProps, {
    getProduct,
    updateProduct
  })(ProductPage)
);
